<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="text-subtitle-1 font-weight-bold">
          Área, puesto, dependencia y funciones
        </div>
      </v-col>
      <v-col cols="6">
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="personal.antiguedadInstitucion"
              label="Antigüedad en la institución"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
            />
            <v-text-field
              v-model="personal.unidadAnalisisTactico"
              label="Dependencia"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
            />
            <v-text-field
              v-model="personal.unidadInvestigacion"
              label="Área de adscripción"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
            />
            <v-text-field
              v-model="personal.unidadOperaciones"
              label="Puesto"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
            />
          </v-col>
          <v-col
            cols="3"
            offset="3"
          >
            <v-btn
              rounded
              color="secondary"
              :disabled="!personalChange"
              @click="triggerUpdatePersonal()"
            >
              Guardar cambios de puesto y adscripción
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="6">
        <v-textarea
          v-model="personal.funciones"
          no-resize
          rounded
          filled
          dense
          color="secondary"
          background-color="primary"
          rows="9"
          label="Funciones"
        />
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <div class="text-subtitle-1 font-weight-bold d-inline">
              Familiares dentro de la institución
            </div>
            <agrega-familiar-dialog-component
              v-if="perfil === 'Antecedentes'"
              :id-personal="personal.idPersonal"
            />
          </v-col>
        </v-row>
        <v-row v-if="familiares.length > 0">
          <v-col
            v-for="familiar in familiares"
            :key="familiar.id"
            cols="3"
          >
            <v-card
              tile
              color="secondary"
            >
              <v-card-title class="d-inline-block">
                <div class="text-subtitle-1 primary--text font-weight-bold">
                  {{ getFullName(familiar) }}
                </div>
                <div class="text-subtitle-2 primary--text">
                  {{ familiar.CatParentesco.title }}
                </div>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col
            cols="12"
            align="center"
          >
            <div class="text-subtitle-1 font-weight-bold text--disabled">
              No hay familiares registrados.
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import AgregaFamiliarDialogComponent from './AgregaFamiliarDialogComponent.vue';

export default {
  components: {
    AgregaFamiliarDialogComponent,
  },

  props: {
    personal: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      personalChange: false,
    };
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('puesto', {
      puestos: 'getPuestos',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    ...mapGetters('rama', {
      ramas: 'getRamas',
    }),

    ...mapGetters('areas', {
      areas: 'getAreas',
    }),

    ...mapGetters('familiares', {
      familiares: 'getFamiliares',
    }),
  },

  watch: {
    personal: {
      handler() {
        this.personalChange = true;
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions('personal', ['updatePersonal']),
    async triggerUpdatePersonal() {
      await this.updatePersonal(this.personal);
    },
  },
};
</script>
